import { ReactComponent as MessageImage } from "assets/images/street-message.svg";
import ContentContainer from "components/ContentContainer";
import { ANIMATION_DURATION } from "components/Message/configs";
import styled from "styled-components";
import { breakpoints } from "theme/breakpoints";

export const FORM_NEGATIVE_OFFSET = -45;

export const Wrapper = styled.div`
  background: linear-gradient(
    ${({ theme }) => theme.colors.secondary} 50%,
    transparent 50%
  );
`;

export const StyledContentContainer = styled(ContentContainer)`
  box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.3);

  @media (max-width: ${breakpoints.lg}) {
    width: 90%;
  }

  @media (max-width: ${breakpoints.md}) {
    width: 100%;
  }
`;

export const PromptContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Container = styled.div`
  z-index: 1;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.light};
  overflow: hidden;
  transition: max-height ${ANIMATION_DURATION};
  padding: 32px 48px;
`;

export const StyledMessageImage = styled(MessageImage)`
  max-width: 200px;
  padding: 20px;
  margin: auto;

  @media (max-width: ${breakpoints.md}) {
    height: unset;
    min-width: 25vw;
  }
`;

export const FormWrapper = styled.div`
  padding: 20px;
  margin-top: ${FORM_NEGATIVE_OFFSET}px;
  margin-left: auto;

  @media (max-width: ${breakpoints.md}) {
    margin-top: 0;
    padding: 0 20px 20px 20px;
    margin-left: unset;
    width: unset;
  }
`;
